/**
 * AskArloPill.js - Header entry point for the chat panel.
 *
 * Self-hiding: useAskArloPanel()'s disabled default covers both the
 * missing-provider and missing-key cases, so Header can render this
 * unconditionally. Fronted by the Arlo "A" mark ("Powered by Arlo").
 */
import React from 'react';
import { useAskArloPanel } from '../../contexts/AskArloContext';

const AskArloPill = () => {
  const { enabled, openPanel } = useAskArloPanel();
  if (!enabled) return null;

  return (
    <button
      type="button"
      onClick={() => openPanel()}
      aria-label="What should I watch?"
      className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium transition-colors border rounded-full text-white/80 border-[#56bdaf]/40 bg-[#56bdaf]/10 hover:bg-[#56bdaf]/20 hover:text-white hover:border-[#56bdaf]/60"
    >
      <img
        src="/assets/images/arlo-mark.svg"
        alt=""
        aria-hidden="true"
        className="w-4 h-4 shrink-0"
      />
      <span className="hidden lg:inline">What should I watch?</span>
    </button>
  );
};

export default AskArloPill;
